/**
 * Whether a policy was sold by an agency, read from the policy's own flag or its originating offer.
 *
 * Imported (migrated) policies never had a Branch offer, so `policy.offer` resolves to null for every
 * guidewire-/imt-conversion term and its renewals. Read it optionally — an unguarded
 * `policy.offer.quote.isAgentSold` threw on the endorsement preview of a migrated CFM auto policy and
 * sent the staff user to the error boundary (#36290).
 */
export const isAgentSoldPolicy = (policy) => Boolean(policy?.isAgentSold || policy?.offer?.quote?.isAgentSold);
